module.exports = __webpack_public_path__ + "img/logo.f10a7733.svg";